<h3 *ngIf="showTitle">Noticias</h3>
<div class="padding-top">
    <div *ngFor="let n of news; let isFirst = first">
        <ng-container *ngIf="n.isAd; else rumorCard">
            <a class="ad-card" target="_blank" href='https://alkorex.com/' [ngClass]="'gray-gradient'">
              <div class="columna">
                <div class="profile-pic">
                  <img src="/assets/AlkoLogo.png" alt="Alkorex">
                </div>
              </div>
              <div class="ad-content">
                <h2>ESTOS RUMORES VAN TAN DUROS COMO ALKOREX</h2>
                <p>
                  Visita su página web y descubre por qué necesitas unas cubiertas engatilladas
                  y cuál es la mejor solución contra filtraciones. Toda la info en:
                <strong>alkorex.com </strong>
                </p>
              </div>
            </a>  
        </ng-container>

        <ng-template #rumorCard>
          <ng-container *ngIf="showTitle; else externalLink">
            <a [routerLink]="'/news/rumores/' + n.rumour._id"
              class="quote-card"
              [ngClass]="{ 'breaking-news': isFirst }">
              <ng-container *ngTemplateOutlet="rumorContent"></ng-container>
            </a>
          </ng-container>

          <ng-template #externalLink>
            <a [href]="n.link"
              target="_blank"
              class="quote-card"
              [ngClass]="{ 'breaking-news': isFirst }">
              <ng-container *ngTemplateOutlet="rumorContent"></ng-container>
            </a>
          </ng-template>

          <!-- Contenido común extraído -->
          <ng-template #rumorContent>
            <div class="quote-content">
              <div *ngIf="isFirst" class="breaking-badge">ÚLTIMA HORA</div>
              <p><strong>{{n.source}}</strong></p>
              <p>{{n.description}}</p>
              <span>{{n.date | date: 'dd-MM-yyyy'}}</span>
            </div>

            <div *ngIf="n.rumour" class="rumour-pill">
              <img *ngIf="n.rumour.player?.imgUrl" [src]="n.rumour.player.imgUrl" alt="Jugador" class="player-photo">
              <img *ngIf="n.rumour.team?.imgUrl" [src]="n.rumour.team.imgUrl" alt="Equipo" class="team-logo">
            </div>
          </ng-template>
        </ng-template>
    </div>
</div>